<template>
    <div>
        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="ins_name" label="机构名称">
            </el-table-column>
            <el-table-column prop="app_key" label="key">
            </el-table-column>
            <el-table-column prop="app_secret" label="安全密钥">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button v-if="!scope.row.app_key" @click="getKey(scope.$index)" type="text" size="small">获取key</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        name: 'admin',
        data() {
            return {
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                }
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    page: this.pagin.pageNum,
                    limit: this.pagin.pageSize,
                }
                this.$http.get('/manage/api-account-info/list', {params:params}).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
            getKey(index) {
                this.$http.post('/manage/api-account-info/save',{insId:this.data[index].ins_id}).then(results => {
                    this.data[index].app_key = results['data']['data']['app_key']
                    this.data[index].app_secret = results['data']['data']['app_secret']
                });
            }
        },
        components: { Pagination }
    }
</script>